/*
  OpenReviews — pilote Manelli (01/10/2026).

  Sur les fiches du pilote, remplace la ligne d'étoiles Avis Vérifiés par une ligne au même dessin
  (carrés #FDC425, étoile blanche, « 4.5/5 - 97 avis »), alimentée par OpenReviews : mêmes note et
  nombre d'avis que le bloc « Avis clients » de la fiche.

  Emplacements posés par snippets/openreviews-syndication.liquid :
    .or-sk-wrap[data-or-layout="product"]  sous le titre de la fiche ; cliquable → ouvre l'onglet
                                           « Avis clients » (ou la fiche, depuis l'aperçu rapide) ;
    .or-sk-wrap[data-or-layout="card"]     cartes produit des listes (dessin des cartes Skeepers) ;
    .or-list-wrap                          bloc d'avis de l'aperçu rapide (HTML inséré après coup :
                                           ses <script> ne s'exécutent pas, on monte le widget ici).
  Le contenu ajouté après le chargement (aperçu rapide, recommandations, sélecteur de chaussures)
  est repris par un MutationObserver. window.ORConfig = { tenant, ids } vient du même snippet.
*/
(function () {
  'use strict';

  if (window.ORStars) {
    window.ORStars.scan(document);
    return;
  }

  var cfg = window.ORConfig || {};
  if (!cfg.tenant) return;

  var API = 'https://api.openreviews.io/v1/augur/synthesis';
  var WIDGET = 'https://api.openreviews.io/augur.js';
  var HEADER_OFFSET = 160; // en-tête collant du site (~140 px)
  var STAR = '<svg viewBox="1.5 1 17 16.3" aria-hidden="true"><path fill="#fff" d="M10 1l2.6 5.3 5.9.9-4.3 4.2 1 5.9L10 14.5l-5.2 2.8 1-5.9L1.5 7.2l5.9-.9z"/></svg>';
  var CSS = [
    '.or-sk{display:inline-flex;align-items:flex-start;padding-top:5px;color:#363636;text-decoration:none}',
    'a.or-sk{cursor:pointer}',
    'a.or-sk:hover .or-sk__text{text-decoration:underline}',
    '.or-sk__stars{display:flex}',
    '.or-sk__item{display:flex;align-items:center;justify-content:center;width:15px;height:15px;margin-right:2px}',
    '.or-sk__item:last-child{margin-right:0}',
    '.or-sk__item svg{width:13px;height:11px;display:block}',
    '.or-sk__text{margin:0 0 0 8px;font-size:14px;line-height:17px;color:#363636}',
    // Cartes : étoiles au-dessus du texte, centrés (comme .grid-product__content .review__header).
    '.or-sk--card{display:flex;flex-direction:column;align-items:center}',
    '.or-sk--card .or-sk__text{margin:0;line-height:18.2px}',
    '@media screen and (min-width:450px){.or-sk--card{display:inline-flex}}'
  ].join('');

  var ids = {};
  (cfg.ids || []).forEach(function (id) { ids[digits(id)] = true; });
  var cache = {};
  // Suivi en mémoire et non par attribut : un carrousel qui clone ses cartes copierait l'attribut,
  // et le clone resterait vide.
  var seen = new WeakSet();

  function digits(v) {
    return String(v == null ? '' : v).replace(/\D/g, '');
  }

  function injectCss() {
    if (document.getElementById('or-sk-css')) return;
    var s = document.createElement('style');
    s.id = 'or-sk-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function synthesis(gtin) {
    if (!cache[gtin]) {
      var url = API + '?gtin=' + encodeURIComponent(gtin) + '&tenant=' + encodeURIComponent(cfg.tenant) + '&locale=fr';
      cache[gtin] = fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[gtin];
  }

  function scrollToReviews() {
    var list = document.getElementById('or-reviews');
    if (!list) return false;
    var wrap = list.closest('.collapsibles-wrapper');
    var trigger = wrap && wrap.querySelector('.collapsible-trigger');
    if (trigger && !trigger.classList.contains('is-open')) trigger.click();
    var target = wrap || list;
    function top() {
      return target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    }
    // Un seul défilement, lancé une fois l'onglet ouvert, puis un recalage quand la page ne bouge plus
    // (le contenu au-dessus peut encore changer de hauteur : images, blocs différés).
    setTimeout(function () {
      window.scrollTo({ top: top(), behavior: 'smooth' });
      var last = -1, still = 0, tries = 0;
      var timer = setInterval(function () {
        var y = window.pageYOffset;
        tries++;
        still = Math.abs(y - last) < 2 ? still + 1 : 0;
        last = y;
        if (still >= 2 || tries > 30) {
          clearInterval(timer);
          if (Math.abs(target.getBoundingClientRect().top - HEADER_OFFSET) > 30) {
            window.scrollTo({ top: top(), behavior: 'auto' });
          }
        }
      }, 120);
    }, 350);
    return true;
  }

  function render(el, d) {
    var n = d && d.total_reviews;
    var avg = d && d.avg_rating;
    if (!n || !avg) {
      el.style.minHeight = '0';
      return;
    }
    injectCss();
    var items = '';
    for (var i = 0; i < 5; i++) {
      var pct = Math.max(0, Math.min(100, Math.round((avg - i) * 100)));
      items += '<span class="or-sk__item" style="background:linear-gradient(to right,#fdc425 0%,#fdc425 ' + pct +
        '%,rgba(253,196,37,.3) ' + pct + '%,rgba(253,196,37,.3) 100%)">' + STAR + '</span>';
    }
    var note = String(Math.round(avg * 10) / 10); // comme Skeepers : « 4.5 », mais « 5 » et non « 5.0 »
    var card = el.getAttribute('data-or-layout') === 'card';
    var href = el.getAttribute('data-or-href');
    var node = document.createElement(card ? 'span' : 'a');
    node.className = card ? 'or-sk or-sk--card' : 'or-sk';
    node.setAttribute('aria-label', note + ' sur 5, ' + n + ' avis');
    node.innerHTML = '<span class="or-sk__stars" aria-hidden="true">' + items + '</span>' +
      // Espacement de Skeepers : « 4.5/5 ␣ - ␣ 97 avis » (espace + insécable de part et d'autre du tiret).
      '<span class="or-sk__text" aria-hidden="true">' + note + '/5 &nbsp;-&nbsp; ' + n + '&nbsp;avis</span>';
    if (!card) {
      // Sur la fiche, l'ancre ne désigne volontairement aucun élément : layout/theme.liquid fait défiler
      // la page vers la cible de tout lien « #… », ce qui entrerait en concurrence avec scrollToReviews.
      node.href = href || '#or-avis';
      node.setAttribute('aria-label', note + ' sur 5, ' + n + ' avis. Voir les avis');
      if (!href) {
        node.addEventListener('click', function (e) {
          e.preventDefault();
          scrollToReviews();
        });
      }
    }
    el.innerHTML = '';
    el.appendChild(node);
  }

  function mountList(el) {
    if (!el.id) el.id = 'or-reviews-' + digits(el.getAttribute('data-or-gtin')) + '-' + Math.random().toString(36).slice(2, 7);
    var s = document.createElement('script');
    s.src = WIDGET;
    s.setAttribute('data-tenant', cfg.tenant);
    s.setAttribute('data-variant', 'rows');
    s.setAttribute('data-seo', 'off');
    s.setAttribute('data-locale', 'fr');
    s.setAttribute('data-gtin', el.getAttribute('data-or-gtin'));
    s.setAttribute('data-target', '#' + el.id);
    el.appendChild(s);
  }

  function load(el) {
    if (el.classList.contains('or-list-wrap')) {
      mountList(el);
      return;
    }
    synthesis(el.getAttribute('data-or-gtin')).then(function (d) { render(el, d); });
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          io.unobserve(en.target);
          load(en.target);
        }
      });
    }, { rootMargin: '300px 0px' })
    : null;

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var found = [];
    if (scope.matches && scope.matches('.or-sk-wrap[data-or-gtin], .or-list-wrap[data-or-gtin]')) found.push(scope);
    Array.prototype.push.apply(found, scope.querySelectorAll('.or-sk-wrap[data-or-gtin], .or-list-wrap[data-or-gtin]'));
    found.forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      // La ligne de la fiche est au-dessus de la ligne de flottaison : pas d'attente.
      if (io && el.getAttribute('data-or-layout') === 'card') io.observe(el);
      else load(el);
    });
  }

  // Emplacement de carte pour du HTML construit en JS (sections/shoe-finder.liquid).
  // Renvoie null hors pilote : l'appelant garde alors les étoiles Avis Vérifiés.
  function card(productId) {
    var gtin = digits(productId);
    if (!ids[gtin]) return null;
    var el = document.createElement('div');
    el.className = 'or-sk-wrap or-sk-wrap--card';
    el.setAttribute('data-or-gtin', gtin);
    el.setAttribute('data-or-layout', 'card');
    el.style.cssText = 'display:block;min-height:41px';
    return el;
  }

  window.ORStars = {
    scan: scan,
    card: card,
    has: function (productId) { return !!ids[digits(productId)]; }
  };

  scan(document);

  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        Array.prototype.forEach.call(r.addedNodes, function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Arrivée depuis l'aperçu rapide (lien « …#or-reviews ») : ouvrir l'onglet des avis.
  if (location.hash === '#or-reviews') {
    window.addEventListener('load', function () { setTimeout(scrollToReviews, 300); });
  }
})();
